import { ConditionalLinkProps } from '@/types/props/components';
import Link from 'next/link';
import { twMerge } from 'tailwind-merge';

export default function ConditionalLink({
  children,
  disabled,
  ...props
}: ConditionalLinkProps) {
  const linkProps = {
    ...props,
    'aria-label': disabled ? 'Link disabled' : (props['aria-label'] ?? ''),
    className: disabled
      ? twMerge(`!tw-pointer-events-none tw-overflow-hidden ${props.className}`)
      : (props.className ?? ''),
    tabIndex: disabled ? -1 : 0,
    href: disabled ? '#' : props.href,
    role: 'link',
  };
  const divProps = {
    style: props.style ?? {},
    'aria-label': disabled ? 'Link disabled' : (props['aria-label'] ?? ''),
    className: disabled
      ? twMerge(`!tw-pointer-events-none tw-overflow-hidden ${props.className}`)
      : (props.className ?? ''),
    tabIndex: disabled ? -1 : 0,
    role: 'link',
  };
  if (disabled) {
    return <div {...divProps}>{children}</div>;
  }
  return <Link {...linkProps}>{children}</Link>;
}
